import { createAction } from 'redux-actions'

export const Set_App_Info = 'set app info'

export const setAppInfo = createAction(Set_App_Info)
